/** @jsx jsx */
import React from 'react'
import { Box, Flex, jsx } from 'theme-ui'
import { theme } from '../../gatsby-plugin-theme-ui/theme'
import { IPositioningMeasurements } from './positionProps'

export const Table: React.SFC<{ measurements: IPositioningMeasurements }> = ({
  measurements,
  children,
}) => {
  return (
    <Box
      sx={{
        top: measurements.verticalTablePadding,
        left: measurements.horizontalTablePadding,
        width: measurements.tableWidth,
        position: 'relative',
        height: measurements.tableHeight,
        bg: 'darkBlue',
        boxSizing: 'content-box',
        borderRadius: 'pill',
        boxShadow: '0px 0px 10px 1px rgba(0,0,0,0.75), inset 0px 0px 10px 1px rgba(0,0,0,0.25)',
      }}
    >
      <Flex
        sx={{
          bg: 'lightBlue',
          borderRadius: 'pill',
          height: [
            `calc(100% - ${theme.space[4] * 2}px)`,
            null,
            null,
            `calc(100% - ${theme.space[5] * 2}px)`,
          ],
          position: 'relative',
          top: [theme.space[4], null, null, theme.space[5]],
          left: [theme.space[4], null, null, theme.space[5]],
          width: [
            measurements.tableWidth - theme.space[4] * 2,
            null,
            null,
            measurements.tableWidth - theme.space[5] * 2,
          ],
          boxShadow:
            'inset 0px 0px 2px 1px rgba(0,0,0,0.75), inset 0px 0px 100px 1px rgba(0,0,0,0.25)',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {children}
      </Flex>
    </Box>
  )
}
